// Google Analytics 4 — passive observer only. Never controls game logic.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let inited = false;

export function initGA() {
  if (inited || !GA_ID) return;
  inited = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!GA_ID || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || !window.gtag) return;
  try { window.gtag("event", name, params); } catch (e) { /* never break the game */ }
}
